import auth0 from 'auth0-js';
import { queryStringUtil } from '../utils/QueryStringUtil';
import getRandomValues from 'polyfill-crypto.getrandomvalues';

const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_ENROLLMENT_CLIENT_ID;
const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;

export default class Auth {
    auth0 = null;
    tokenRenewalTimeout = null;
    loggingOut = false;

    constructor(){
        var enrolleeParam = queryStringUtil.getQueryParam('enrollee');
        this.auth0 = new auth0.WebAuth({
            domain: `${AUTH0_DOMAIN}`,
            clientID: `${AUTH0_CLIENT_ID}`,
            redirectUri: `${window.location.protocol}//${window.location.hostname}${(window.location.port ? ':' + window.location.port : '')}/callback${enrolleeParam ? `?enrollee=${enrolleeParam}` : ''}`,
            audience: `${AUTH0_AUDIENCE}`,
            responseType: 'token id_token',
            scope: 'openid profile email groups',
            nonce: this.randomString(16)
        });
        this.scheduleRenewal();
    }

    login = () => {
        this.auth0.authorize();
    };

    handleAuthentication = () => {
        return new Promise((resolve, reject) => {
            this.auth0.parseHash((err, authResult) => {
                if(authResult && authResult.accessToken && authResult.idToken){
                    this.setSession(authResult);
                    resolve(authResult);
                } else if(err) {
                    reject(null);
                }
            });
        });
    };

    setSession = (authResult) => {
        const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);

        this.scheduleRenewal();
    };

    logout = () => {
        this.loggingOut = true;
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');

        clearTimeout(this.tokenRenewalTimeout);
        
        window.location.href = `https://${AUTH0_DOMAIN}/v2/logout?client_id=${AUTH0_CLIENT_ID}&returnTo=${window.location.origin}/logout`;
        return false;
    };

    isAuthenticated = () => {
        if(!this.loggingOut){
            const expiresAtStorage = localStorage.getItem('expires_at');

            if(expiresAtStorage){
                const expiresAt = JSON.parse(expiresAtStorage);
                return new Date().getTime() < expiresAt;
            }

            return false;
        } else {
            return true;
        }
    };

    renewToken = () => {
        this.auth0.checkSession({}, (err, result) => {
            if(err){
                //console.log(err);
            }else{
                this.setSession(result);
            }
        });
    };

    scheduleRenewal = () => {
        const expiresAt = parseFloat(localStorage.getItem('expires_at'));
        const delay = new Date(expiresAt).setMinutes(new Date(expiresAt).getMinutes() - 5) - Date.now();
        //-300000 is 5 minutes after our delay is set so we still have time to renew the token
        //this is incase of page refresh during the 5 minute difference we are checking
        if (delay > -300000) {
            this.tokenRenewalTimeout = setTimeout(() => {
                this.renewToken();
            }, delay);
        }
    };

    randomString = (length) => {
        var bytes = new Uint8Array(length);
        var cryptoObj = window.crypto || window.msCrypto;
        var random = 0;
        if(cryptoObj){
            random = cryptoObj.getRandomValues(bytes);
        }else{
            random = getRandomValues(bytes);
        }
        var result = [];
        var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
        
        for(let i = 0; i < random.length; i++){
            result.push(charset[random[i] % charset.length]);
        }

        return result.join('');
    };
}